import { render, staticRenderFns } from "./ConfigurationButtons.vue?vue&type=template&id=17513464"
import script from "./ConfigurationButtons.vue?vue&type=script&lang=js"
export * from "./ConfigurationButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports